/* eslint-disable @typescript-eslint/no-non-null-assertion */ // TODO Fix

import React from "react";

import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { CodeName } from "~/services/webapi/types";

import AgencySelector from "~/components/AgencySelector";
import { OneButtonBottomPane } from "~/components/BottomButtonsPane";
import CodeNameSelector from "~/components/CodeNameSelector";
import { InjectedI18nProps, withI18n } from "~/services/i18n";

const styles = () =>
  createStyles({
    button: {
      alignSelf: "flex-end",
      marginLeft: 20,
      marginTop: 20,
    },
    fill: {
      flexGrow: 1,
      flexShrink: 1,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
    },
    root: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 0,
    },
  });

export interface Props extends WithStyles<typeof styles> {
  /** Código de agencia seleccionado. */
  agencyCode?: string;

  /**
   * Indica que no se deben cargar datos. Se usa si hay error de carga de
   * destinos para no entrar en bucle de errores.
   */
  dataLoadError?: boolean;
  destinationCode?: string;
  destinations?: CodeName[];
  duration?: string;
  durations?: CodeName[];
  excursion?: string;
  excursions?: CodeName[];
  excursionType?: string;
  excursionTypes?: CodeName[];
  feature?: string;
  features?: CodeName[];
  fetchDestinations: () => void;
  fetchExcursions: (destinationCode: string) => void;
  modalities?: CodeName[];
  modality?: string;
  onDestinationChange: (value: string) => void;
  onDurationChange: (value: string) => void;
  onExcursionChange: (value: string) => void;
  onExcursionTypeChange: (value: string) => void;
  onFeaturechange: (value: string) => void;
  onModaliytChange: (value: string) => void;
  onReload: () => void;
  onSearch: (excursionCode: string, modalityCode: string) => void;
  onSegementatonChange: (value: string) => void;
  segmentation?: string;
  segmentations?: CodeName[];
  /* Indica si se debe mostrar el selector de agencia. */
  showAgency?: boolean;
}

interface ProvidedProps extends Props, InjectedI18nProps {}

/**
 * Pantalla de búsqueda o selección de excursión.
 */
class SearcherView extends React.PureComponent<ProvidedProps, { redirect: boolean }> {
  public componentDidMount() {
    this.checkData();
  }
  public componentDidUpdate(prevProps: ProvidedProps) {
    this.checkData(prevProps);
  }

  /** #render */
  public render() {
    const margin = "dense";
    const { formatMessage } = this.props.i18n;

    if (this.props.dataLoadError) {
      /*
       * No cargamos datos porque está fallando. Notificamos con un mensaje y
       * ponemos un botón de reintentar carga.
       */
      return (
        <div className={this.props.classes.root}>
          <form className={this.props.classes.form}>
            <Typography>{formatMessage("searcherView.unableToLoadDestinations")}</Typography>
            <OneButtonBottomPane
              nextEnabled={true}
              nextLabel={formatMessage("searcherView.retry")}
              onNext={this.props.onReload}
            />
          </form>
        </div>
      );
    }

    return (
      <div className={this.props.classes.root}>
        <form className={this.props.classes.form}>
          {this.props.showAgency && <AgencySelector />}
          <CodeNameSelector
            label={formatMessage("searcherView.destination")}
            margin={margin}
            selectedCode={this.props.destinationCode}
            values={this.props.destinations}
            onValueChange={this.props.onDestinationChange}
          />
          <CodeNameSelector
            addEmpty={true}
            margin={margin}
            label={formatMessage("searcherView.excursionType")}
            selectedCode={this.props.excursionType}
            values={this.props.excursionTypes}
            onValueChange={this.props.onExcursionTypeChange}
          />
          <CodeNameSelector
            label={formatMessage("searcherView.excursion")}
            margin={margin}
            selectedCode={this.props.excursion}
            values={this.props.excursions}
            onValueChange={this.props.onExcursionChange}
          />
          <CodeNameSelector
            addEmpty={true}
            label={formatMessage("searcherView.segmentation")}
            margin={margin}
            selectedCode={this.props.segmentation}
            values={this.props.segmentations}
            onValueChange={this.props.onSegementatonChange}
          />
          <CodeNameSelector
            addEmpty={true}
            label={formatMessage("searcherView.feature")}
            margin={margin}
            selectedCode={this.props.feature}
            values={this.props.features}
            onValueChange={this.props.onFeaturechange}
          />
          <CodeNameSelector
            addEmpty={true}
            margin={margin}
            label={formatMessage("searcherView.duration")}
            selectedCode={this.props.duration}
            values={this.props.durations}
            onValueChange={this.props.onDurationChange}
          />
          <CodeNameSelector
            label={formatMessage("searcherView.modality")}
            margin={margin}
            selectedCode={this.props.modality}
            values={this.props.modalities}
            onValueChange={this.props.onModaliytChange}
          />
          <OneButtonBottomPane
            nextEnabled={!!this.props.excursion && !!this.props.modality}
            nextLabel={formatMessage("searcherView.search")}
            onNext={this.onSearch}
          />
        </form>
      </div>
    );
  }

  private checkData(prevProps?: ProvidedProps) {
    if (!this.props.dataLoadError) {
      if (
        this.props.agencyCode &&
        (this.props.destinations === undefined || this.props.agencyCode !== prevProps?.agencyCode)
      ) {
        this.props.fetchDestinations();
      } else if (this.props.excursions === undefined && this.props.destinationCode) {
        this.props.fetchExcursions(this.props.destinationCode);
      }
    }
  }

  private onSearch = () => {
    this.props.onSearch(this.props.excursion || "", this.props.modality || "");
  };
}

export default withI18n(withStyles(styles)(SearcherView));
